// Dependencies
import React from 'react';

import PropTypes from 'prop-types';

// Local Components
import GuideDownloadCta from '../guide-download-cta/guide-download-cta';
import GuideSignUpCta from '../guide-sign-up-cta/guide-sign-up-cta';

const GuideCta = ({ isSignedIn, trackingId, impressionPayload }) => {
  return (
    <Choose>
      <When condition={isSignedIn}>
        <GuideDownloadCta trackingId={`${trackingId}_download`} />
      </When>
      <Otherwise>
        <GuideSignUpCta
          trackingId={trackingId}
          impressionPayload={impressionPayload}
        />
      </Otherwise>
    </Choose>
  );
};

GuideCta.propTypes = {
  trackingId: PropTypes.string,
  isSignedIn: PropTypes.bool,
  impressionPayload: PropTypes.object,
};

GuideCta.defaultProps = {
  isSignedIn: false,
  trackingId: 'home_buying_guide',
  impressionPayload: {},
};

export default GuideCta;
